import { isDingdingMiniapp } from "../_utils/miniappEnvApp";
import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var downloadFile = normalize.download(function (options) {
  var url = options.url,
      header = options.header,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;

  var _downloadFile = isDingdingMiniapp ? dd.downloadFile : my.downloadFile;

  _downloadFile({
    url: url,
    header: header,
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.ALIPAY);
export default downloadFile;